import { useEffect } from "react";

export const MidtransScript = () => {
  useEffect(() => {
    const clientKey = import.meta.env.VITE_MIDTRANS_CLIENT_KEY;

    if (!clientKey) {
      console.error("❌ Midtrans Client Key belum terisi di .env");
      return;
    }

    const scriptTag = document.createElement("script");

    // ✅ Gunakan URL production Midtrans Snap
    scriptTag.src = "https://app.midtrans.com/snap/snap.js";
    scriptTag.setAttribute("data-client-key", clientKey);
    scriptTag.async = true;

    document.body.appendChild(scriptTag);

    return () => {
      document.body.removeChild(scriptTag);
    };
  }, []);

  return null;
};
